const httpFetch = async (path, data, options = {}) => {
  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
  };

  if (data !== undefined) {
    defaultOptions.body = JSON.stringify(data);
  }

  const response = await fetch(`${process.env.VUE_APP_API}/api/v2` + path, {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  });

  let error;
  if (!response.ok) {
    error = await response.clone().json();
  }

  const text = await response.text();
  if (text.length > 0) {
    if (!response.ok) {
      error.data = JSON.parse(text);

      throw error;
    } else {
      return JSON.parse(text);
    }
  } else if (!response.ok) {
    throw error;
  }
};

export const http = {
  async get(path, data, options = {}) {
    return await httpFetch(path, data, { method: "GET", ...options });
  },
  async post(path, data, options = {}) {
    return await httpFetch(path, data, { method: "POST", ...options });
  },
  async delete(path, data, options = {}) {
    return await httpFetch(path, data, { method: "DELETE", ...options });
  },
  async put(path, data, options = {}) {
    return await httpFetch(path, data, { method: "PUT", ...options });
  },
};
